import React from 'react'
import Textarea from 'react-textarea-autosize'

function moveCursorToEnd(e) {
    const temp = e.target.value
    e.target.value = ''
    e.target.value = temp
}

function DescriptionField({ onChange, value, autoFocus=false, minRows=1 }) {
    return (
        <Textarea
            value={value}
            onChange={onChange}
            className="description-field"
            placeholder="Description (optional)"
            minRows={minRows}
            autoFocus={autoFocus}
            onFocus={moveCursorToEnd}
        />
    )
}

export default DescriptionField


// WEBPACK FOOTER //
// ./src/components/description_field.jsx